/*参数说明
*   $obj 为jquery对象，是需要该插件调整样式的目标元素；
*
* */
// import './colorpicker/jquery.colorPicker.js'
//  require('./colorpicker/jquery.colorPicker.js')
export function FontEdit($obj) {    
require('./colorpicker/jquery.colorPicker.js')
    var $font_edit = $('#font_edit');

    if($font_edit.length) {
        return;
    }

    var _tpl = '<fieldset id="font_edit">\
      <div>样式预览</div>\
      <div class="font_edit_preview">文本示例</div>\
      <table>\
      <tr>\
      <th>颜色</th>\
      <td><input class="font_edit_color"></td>\
      </tr>\
      <tr>\
      <th>字体</th>\
      <td>\
      <select class="font_edit_type" data-key="font-family">\
      <option value="宋体">宋体</option>\
      <option value="微软雅黑">雅黑</option>\
      <option value="楷体">楷体</option>\
      <option value="黑体">黑体</option>\
      </select>\
      </td>\
      </tr>\
      <tr>\
      <th>大小</th>\
      <td>\
      <select class="font_edit_size" data-key="font-size">\
      <option value="12">12</option>\
      <option value="13">13</option>\
      <option value="14">14</option>\
      <option value="15">15</option>\
      <option value="16" selected>16</option>\
      <option value="17">17</option>\
      <option value="18">18</option>\
      <option value="19">19</option>\
      <option value="20">20</option>\
      </select>\
      </td>\
      </tr>\
      <tr>\
      <th>样式</th>\
      <td class="font_edit_style">\
      <a class="bold_font" title="加粗" data-key="font-weight" data-value="bold">B</a>\
      <a class="italic_font" title="倾斜" data-key="font-style" data-value="italic">I</a>\
      <a class="underline_font" title="下划线" data-key="text-decoration" data-value="underline">U</a>\
      </td>\
      </tr>\
      </table>\
      <div class="font_edit_setting">\
      <a href="#" class="ensure">确定</a>\
      <a href="#" class="cancel">取消</a>\
      </div>\
      </fieldset>';
    var $editor = $('body');

    $editor.append(_tpl);

    $font_edit = $('#font_edit');

    // set fonts init values
    var fonts = {};

    fonts.color = $obj.css("color");
    fonts.family = $obj.css("font-family");
    fonts.size = $obj.css("font-size");
    fonts.weight = $obj.css("font-weight");
    fonts.style = $obj.css("font-style");
    fonts.textDecoration = $obj.css("text-decoration");

    // set init preview style
    $('.font_edit_preview').css({
        "color": fonts.color,
        "font-family": fonts.family,
        "font-size": fonts.size,
        "font-weight": fonts.weight,
        "font-style": fonts.style,
        "text-decoration": fonts.textDecoration
    });

    //radios set init value
    $('.font_edit_color').colorPicker({
        pickerDefault: fonts.color,
        parent: $font_edit,
        onColorChange: function () {
            $('.font_edit_preview').css("color",arguments[1]);
        }
    });

    $('.font_edit_type').val(fonts.family);

    $('.font_edit_size').val(parseInt(fonts.size));

    if (fonts.weight == 'bold') {
        $('.font_edit_style >.bold_font').addClass('selected_font');
    }

    if (fonts.style == 'italic') {
        $('.font_edit_style >.italic_font').addClass('selected_font');
    }

    if (fonts.textDecoration == 'underline') {
        $('.font_edit_style >.underline_font').addClass('selected_font');
    }

    $('.font_edit_type').on('change',function () {
        var $selectedOpt = $(this).find('option:selected');
        var value = $selectedOpt.val();
        $('.font_edit_preview').css("font-family",value);
    });

    $('.font_edit_size').on('change',function () {
        var $selectedOpt = $(this).find('option:selected');
        var value = $selectedOpt.val() + 'px';

        $('.font_edit_preview').css("font-size",value);
    });

    $('.font_edit_style').delegate('a','click',function () {

        $(this).toggleClass('selected_font');

        var isHave = $(this).hasClass('selected_font');

        var key = $(this).attr('data-key');
        var value = $(this).attr('data-value');

        if (isHave) {

            $('.font_edit_preview').css(key,value);

        }else {

            if (key=='font-weight' ||  key=='font-style') {

                $('.font_edit_preview').css(key,'normal');

            }else if (key == 'text-decoration') {
                $('.font_edit_preview').css(key,'none');

            }
        }

    });

    $('.font_edit_setting >.ensure').on('click',function () {

        var $preview = $('.font_edit_preview');

        fonts.color = $preview.css("color");
        fonts.family = $preview.css("font-family");
        fonts.size = $preview.css("font-size");
        fonts.weight = $preview.css("font-weight");
        fonts.style = $preview.css("font-style");
        fonts.textDecoration = $preview.css("text-decoration");

        $obj.css({
            "color": fonts.color,
            "font-family": fonts.family,
            "font-size": fonts.size,
            "font-weight": fonts.weight,
            "font-style": fonts.style,
            "text-decoration": fonts.textDecoration
        });

        $('#font_edit').remove();

    });

    $('.font_edit_setting >.cancel').on('click',function () {
        $('#font_edit').remove();
    });
}

